'use strict';

export default function ($stateProvider, $urlRouterProvider) {
  'ngInject';

  $urlRouterProvider.when("/dictionaries", "/dictionaries/list");
  $stateProvider
    .state('dictionaries', {
      url: '/dictionaries',
      template: require('./dictionaries.html'),
      authenticate: true
    })
    .state('dictionaries.list', {
      url: '/list',
      template: require('./list/list.html'),
      controller: 'DictionariesListController',
      controllerAs: 'dictListCtrl'
    })
    .state('dictionaries.edit', {
      url: '/edit/:id',
      template: require('./edit/edit.html'),
      controller: 'DictionariesEditController',
      controllerAs: 'dictEdittCtrl'
    })
    .state('dictionaries.add', {
      url: '/add',
      template: require('./add/add.html'),
      controller: 'DictionariesAddController',
      controllerAs: 'dictAddCtrl'
    });
}



// WEBPACK FOOTER //
// ./client/app/dictionaries/dictionaries.routes.js